import { atom } from 'recoil';
import { getRecoil } from 'recoil-nexus';

import { IClientConfig } from '../client-config/config';
import { OddsFormat, TranslateFunc } from '../constants/types';

import DefaultConfig from '../client-config/default.json';
import { IAuthData, IBonusRule, ICurrencyConfig, IPartnerConfig } from 'src/constants/interfaces';
import { IVerificationResolver, IVerificationResponse } from 'src/constants/interfaces/verification';
import { IFreeBonus, ISelection } from 'src/constants/interfaces/bet';
import _ from 'lodash';

export interface IUpperDataStore {
  balance: number;
  translate: TranslateFunc,
  config: IClientConfig,
  authData: IAuthData;
  oddsFormat: OddsFormat;
  userId: number,
  bonusRules: IBonusRule[];
  partnerConfig?: IPartnerConfig;
  currencyConfig?: ICurrencyConfig;
  verificationResolver?: IVerificationResolver;
  verificationResponse?: IVerificationResponse | null;
  memberId?: string;
  freeBonuses: IFreeBonus[];
  transformSelection(selection: ISelection): ISelection;
};

const upperDataStore = atom<IUpperDataStore>({
  key: 'upperDataStore',
  default: {
    balance: 0,
    userId: 0,
    translate: str => str,
    oddsFormat: 'decimal',
    config: DefaultConfig as IClientConfig,
    authData: { token: '', currency: '', tid: 0, pid: 0 },
    bonusRules: [],
    freeBonuses: [],
    transformSelection: _.identity,
  },
});

export const storeGetConfig = () => {
  const { config } = getRecoil(upperDataStore);
  return config;
};

export default upperDataStore;
